// extracted by mini-css-extract-plugin
module.exports = {"lbl":"PrintDialog_lbl_3VHbf","button":"PrintDialog_button_1LYyX","icon":"PrintDialog_icon_2flbl"};